module.exports = __webpack_public_path__ + "img/platform-ux-32.5a098912.svg";